import React from 'react';
import ContentLoader from 'react-content-loader';
import '../components/Slide/Slide.scss';

const MyLoader = (props) => {
  return (
    <ContentLoader
      className={`slide__image-container slide__image_skeleton ${props.isLoaded ? 'loaded' : ''}`}
      speed={2}
      width={501}
      height={570}
      viewBox="0 0 501 570"
      backgroundColor="#f3f3f3"
      foregroundColor="#ecebeb"
      {...props}>
      <rect x="0" y="0" rx="15" ry="15" width="501" height="570" />
    </ContentLoader>
  );
};

export default MyLoader;
